import { useEffect } from 'react';
import {
  useAnnotationSolo,
  useSelectedCommentId,
  useSelectionActions,
} from '../model/comments.store';

const SAFE_SELECTORS = [
  '[data-comment-id]',
  '[data-annotation-overlay]',
  '[data-radix-popper-content-wrapper]',
  '[role="dialog"]',
  '[role="menu"]',
].join(',');

export function useDeselectOnOutsideClick() {
  const selectedCommentId = useSelectedCommentId();
  const { clearSelectedComment } = useSelectionActions();
  const { clearSolo } = useAnnotationSolo();

  useEffect(() => {
    if (!selectedCommentId) return;
    const handlePointerDown = (event: PointerEvent) => {
      const target = event.target as Element | null;
      if (target?.closest(SAFE_SELECTORS)) return;
      clearSelectedComment();
      clearSolo();
    };
    document.addEventListener('pointerdown', handlePointerDown, true);
    return () => document.removeEventListener('pointerdown', handlePointerDown, true);
  }, [selectedCommentId, clearSelectedComment, clearSolo]);
}
